<template>
  <el-card class="box-card card-table">
    <div slot="header" class="card-header clearfix " :class="{ 'without-search': disable_search}">
      <input type="search" v-model="term" @input="onSearchChange" placeholder="Buscar" class="search" v-if="!disable_search">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="total">
      </el-pagination>
    </div>
    <slot></slot>
  </el-card>
</template>

<script>
  export default {
    name: 'app-table',
    props: ['total', 'current_page', 'disable_search'],
    data () {
      return {
        term: ''
      }
    },
    methods: {
      handleCurrentChange (event) {
        this.$emit('change-pagination', event)
      },
      onSearchChange () {
        this.$emit('change-search', this.term)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Table.vue